import { useCallback, useState } from "react";

type Action = "like" | "dislike" | "navigate";

interface ActionHistory {
  action: Action;
  mealId: string;
}

const actionHandler =
  (action: Action, mealId: string) => (prevActionHistory: ActionHistory[]) => {
    const lastAction = prevActionHistory[prevActionHistory.length - 1];

    if (!!lastAction) {
      if (lastAction?.action === action && lastAction?.mealId === mealId) {
        return prevActionHistory;
      }
    }
    const newActionHistory = [...prevActionHistory];
    newActionHistory.push({
      action: action,
      mealId: mealId,
    });
    return newActionHistory;
  };

export const useActionHistory = () => {
  const [actionHistory, setActionHistory] = useState<ActionHistory[]>([]);

  const logLikeAction = useCallback((mealId: string) => {
    setActionHistory(actionHandler("like", mealId));
  }, []);

  const logDislikeAction = useCallback((mealId: string) => {
    setActionHistory(actionHandler("dislike", mealId));
  }, []);

  const logNavigateToAction = useCallback((mealId: string) => {
    setActionHistory(actionHandler("navigate", mealId));
  }, []);

  const popLastAction = useCallback(() => {
    const lastAction = actionHistory.pop();
    setActionHistory(actionHistory);
    return lastAction;
  }, [actionHistory]);

  const getLastAction = useCallback(() => {
    const lastAction = actionHistory[actionHistory.length - 1];
    return lastAction;
  }, [actionHistory]);

  return {
    actionHistory,
    setActionHistory,
    logLikeAction,
    logDislikeAction,
    logNavigateToAction,
    getLastAction,
    popLastAction,
  };
};
